import { CommApiInstance } from "Utils/CommApiInstance";


const EmlAthnNoVrfRqstFirstApi = async (
    athnNo:string,
    ReCaptchaToken:string,
    membBirthday:string,
    membGender:string
) => {
    return await CommApiInstance.post(`athn/idnt_mthd/eml/athn_no_vrf/first`,{
        apiBody: {
            athnNo:athnNo,
            cptchTkn:ReCaptchaToken,
            dob: membBirthday,
            gndr: membGender
        }
    })
    .then((Resp) => Resp.data);
}

export default EmlAthnNoVrfRqstFirstApi;